import MethodLogo from "./methodLogos";
import { CheckIcon } from "./icons";
import { __ } from "services/Translator";

// Serving-contract badge labels (mirrors the builder + useCashierData order).
// Rendered as pills so every BO-enabled badge is shown, not just the first one
// folded into text.
const BADGE_LABELS = { instant: "Instant", recommended: "Recommended", popular: "Popular" };

export default function MethodTile({ method, selected, onSelect }) {
  const badges = Array.isArray(method.badges) ? method.badges : [];
  return (
    <div
      className={selected ? "tile sel" : "tile"}
      onClick={() => onSelect(method)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(method);
        }
      }}
    >
      <div className="check">
        <CheckIcon />
      </div>
      <MethodLogo name={method.name} label={method.label || method.name} logo={method.logo} />
      <div className="mtext">
        <b>{method.label || method.name}</b>
        {badges.length ? (
          <div className="badges">
            {badges.map((b) => (
              <span key={b} className={`badge ${b}`}>
                {__(BADGE_LABELS[b] || b)}
              </span>
            ))}
          </div>
        ) : null}
        {method.sub ? <s>{method.sub}</s> : null}
      </div>
    </div>
  );
}
